import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['../footer-header-styles/header.footer.component.css']
})
export class FooterComponent implements OnInit {
    constructor() {

    }
    ngOnInit() {}

}



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.ts